import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BTaxBill } from 'egov-api';

@Component({
    selector: 'btax-tax-year',
    template: `
        <ng-container *ngIf="bill">{{ bill.taxYear }}</ng-container>
        <egov-text-ui-placeholder *ngIf="!bill">0000</egov-text-ui-placeholder>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BTaxTaxYearComponent
{
    @Input() protected bill?: BTaxBill;
}
